import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=5668041a&scoped=true&"
import script from "./SendMessageModal.vue?vue&type=script&lang=js&"
export * from "./SendMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageModal.vue?vue&type=style&index=0&id=5668041a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5668041a",
  null
  
)

export default component.exports